import addMinutes from 'date-fns/addMinutes';
import endOfDay from 'date-fns/endOfDay';
import formatDate from 'date-fns/format';
import isBefore from 'date-fns/isBefore';
import startOfDay from 'date-fns/startOfDay';

import { KeyCodes } from '../../consts/keyCodes';

export const FORMAT_12H = 'hh:mm aa';
export const FORMAT_24H = 'HH:mm';

/**
 * Set only time to target date
 *
 * eg;    target Date: 2020-01-05 10:00:00
 *        from Date: 2020-01-01 12:00:00
 *     -- return: 2020-01-05 12:00:00
 *
 * @param targetDate
 * @param fromDate
 * @param optional
 */
export function setTimeToTargetFromDate(
  targetDate: Date,
  fromDate: Date,
  optional: { setSeconds?: boolean } = {},
) {
  const offsetTime = new Date(targetDate.valueOf());
  offsetTime.setHours(fromDate.getHours());
  offsetTime.setMinutes(fromDate.getMinutes());
  if (optional.setSeconds) {
    offsetTime.setSeconds(fromDate.getSeconds());
  }
  return offsetTime;
}

export const convertTo12HourFormat = (time: Date) => {
  if (!time) {
    return '';
  }
  return formatDate(time, FORMAT_12H);
};

export const getTimeSelectorOptions = (params: {
  value: Date;
  timeInterval: number;
  timeFormat: string;
}) => {
  const { timeFormat, timeInterval, value } = params;

  const timeSelectorOptions = [];

  let timeSelectorValue = addMinutes(startOfDay(value), timeInterval); // skip 12:00 AM
  const endOfDayValue = endOfDay(value);

  do {
    timeSelectorOptions.push({
      value: timeSelectorValue,
      label: formatDate(timeSelectorValue, timeFormat),
    });
    timeSelectorValue = addMinutes(timeSelectorValue, timeInterval);
  } while (isBefore(timeSelectorValue, endOfDayValue));

  return timeSelectorOptions;
};

export const handleNativeTimePicker = (event: any) => {
  //pressing spacebar opens browser's native time picker, prevent it from opening
  if ([KeyCodes.Space].includes(event.key)) {
    event.preventDefault();
  }
};
